// extracted by mini-css-extract-plugin
module.exports = {"vertical-nav-bar-container":"vertical-nav-bar-container-AsGLM","nav-tab-button":"nav-tab-button-noMv6"};